import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../lib/api';
import { setAdminSession } from '../lib/auth';

export function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await adminApi.login({ email, password });
      setAdminSession({
        token: res.token,
        email: res.email,
        expiresAt: new Date(res.expires_at),
      });
      nav('/', { replace: true });
    } catch (err) {
      const e = err as { status?: number; error?: string };
      if (e.status === 503) {
        setError('어드민이 서버에서 활성화되지 않았습니다. 운영자에게 문의하세요.');
      } else if (e.status === 401) {
        setError('이메일 또는 비밀번호가 올바르지 않습니다.');
      } else {
        setError(`로그인 실패 (${e.error ?? 'unknown'})`);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={submit} className="card w-full max-w-sm flex flex-col gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-text-muted">Butler</div>
          <h1 className="text-xl font-semibold text-text-primary mt-1">백오피스 로그인</h1>
        </div>
        <label className="flex flex-col gap-1.5">
          <span className="text-xs text-text-secondary">이메일</span>
          <input
            type="email"
            autoComplete="email"
            required
            className="input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@example.com"
          />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="text-xs text-text-secondary">비밀번호</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {error && (
          <div className="text-xs text-error bg-error/10 border border-error/40 rounded-md px-3 py-2">
            {error}
          </div>
        )}
        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? '로그인 중…' : '로그인'}
        </button>
      </form>
    </div>
  );
}
